import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { addToCart } from "../../store/actions/cartActions";
import ShopProduct from '../../components/ShopProduct';
import { getProducts } from "../../api/backend";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/gattomioNero.png';

const ShopPage = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState({});
    const [products, setProducts] = useState([]);
    const [productsLoading, setProductsLoading] = useState(true);
    const [productsError, setProductsError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationData, setPaginationData] = useState(null);

    // Carica prodotti dal backend
    useEffect(() => {
        const fetchProducts = async () => {
            setProductsLoading(true);
            setProductsError(null);

            try {
                const response = await getProducts({ page: currentPage });
                // Gestione risposta impaginata di Laravel
                const productsData = response.data || response;
                
                // Mappatura campi database -> campi componente
                const mappedProducts = productsData.map(product => ({
                    ...product,
                    title: product.name,
                    proImg: product.proImg,
                    delPrice: product.price,
                    price: product.sale_price || product.price
                }));
                
                setProducts(mappedProducts);
                
                // Salva dati paginazione se presenti
                if (response.meta || response.current_page) {
                    setPaginationData({
                        currentPage: response.current_page || response.meta?.current_page,
                        lastPage: response.last_page || response.meta?.last_page,
                        total: response.total || response.meta?.total,
                        perPage: response.per_page || response.meta?.per_page
                    });
                }
            } catch (error) {
                console.error('Errore caricamento prodotti:', error);
                setProductsError(error.message || 'Errore durante il caricamento dei prodotti');
                toast.error('Impossibile caricare i prodotti');
            } finally {
                setProductsLoading(false);
            }
        };

        fetchProducts();
    }, [currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        window.scrollTo(0, 0);
    };

    const addToCartProduct = async (product, qty = 1) => {
        // Verifica che il prodotto abbia un ID
        if (!product.id) {
            toast.error('Prodotto non valido');
            return;
        }

        setLoading(prev => ({ ...prev, [product.id]: true }));

        try {
            await dispatch(addToCart(product.id, qty));
            toast.success(`${product.title} aggiunto al carrello!`);
        } catch (error) {
            console.error('Errore aggiunta al carrello:', error);
            toast.error(error.message || 'Errore durante l\'aggiunta al carrello');
        } finally {
            setLoading(prev => ({ ...prev, [product.id]: false }));
        }
    };

    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={'Shop'} pagesub={'Shop'} />
            <section className="wpo-shop-page section-padding pb-200">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            {productsLoading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Caricamento...</span>
                                    </div>
                                    <p className="mt-3">Caricamento prodotti...</p>
                                </div>
                            ) : productsError ? (
                                <div className="alert alert-danger text-center" role="alert">
                                    <h4 className="alert-heading">Errore</h4>
                                    <p>{productsError}</p>
                                    <button
                                        className="btn btn-primary mt-3"
                                        onClick={() => window.location.reload()}
                                    >
                                        Riprova
                                    </button>
                                </div>
                            ) : products.length === 0 ? (
                                <div className="alert alert-info text-center" role="alert">
                                    <h4>Nessun prodotto disponibile</h4>
                                    <p>Torna più tardi per vedere i nostri prodotti</p>
                                </div>
                            ) : (
                                <ShopProduct
                                    addToCartProduct={addToCartProduct}
                                    products={products}
                                    loading={loading}
                                    paginationData={paginationData}
                                    onPageChange={handlePageChange}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </section>
            <Footer/>
            <Scrollbar />
        </Fragment>
    )
};

export default ShopPage;